module.exports = __webpack_public_path__ + "img/14.d5a3fe89.jpg";